module.exports = __webpack_public_path__ + "img/0866ed5.png";